import type { PatientMeasurementField } from '../types';
import { BASE_MEASUREMENT_FIELD_DEFINITIONS } from './measurements';

export const MEASUREMENT_FIELD_REQUIRED_MESSAGE = 'Campo obbligatorio';
export const MEASUREMENT_FIELD_INVALID_MESSAGE =
  'Inserisci un valore numerico valido';
export const MEASUREMENT_INCOMPLETE_MESSAGE =
  'Compila tutti i campi della rilevazione prima di salvare.';

export const validateMeasurementFieldValue = (value: string): string | null => {
  const trimmed = value.trim();
  if (trimmed === '') {
    return MEASUREMENT_FIELD_REQUIRED_MESSAGE;
  }

  const parsed = Number(trimmed.replace(',', '.'));
  if (!Number.isFinite(parsed) || parsed <= 0) {
    return MEASUREMENT_FIELD_INVALID_MESSAGE;
  }

  return null;
};

export const arePatientMeasurementFieldsComplete = (
  fields: PatientMeasurementField[]
): boolean =>
  BASE_MEASUREMENT_FIELD_DEFINITIONS.every(definition => {
    const field = fields.find(
      item => item.metricType === definition.metricType
    );
    return field != null && validateMeasurementFieldValue(field.value) == null;
  }) &&
  fields
    .filter(field => field.scope === 'extra')
    .every(field => validateMeasurementFieldValue(field.value) == null);

export const buildPatientMeasurementFieldErrors = (
  fields: PatientMeasurementField[]
): Record<string, string | null> => {
  const errors: Record<string, string | null> = {};

  fields.forEach((field, index) => {
    if (
      field.scope === 'extra' ||
      field.scope === 'base' ||
      field.scope == null
    ) {
      const message = validateMeasurementFieldValue(field.value);
      if (message != null) {
        errors[`fields.${index}.value`] = message;
      }
    }
  });

  return errors;
};
